/** @jsxImportSource @emotion/react */
import { ReactNode } from 'react';
import { useTheme } from '../..';

interface Props {
  children?: ReactNode;
  className?: string;
}

export const Card = ({ children, className }: Props) => {
  const { palette, shape, spacing } = useTheme();
  return (
    <div
      css={{
        background: palette.white,
        borderRadius: shape.borderRadius,
        padding: spacing.xxs,
        border: `1px solid ${palette.grey.x100}`,
      }}
      className={className}
    >
      {children}
    </div>
  );
};
